import React from 'react'
import ReactHtmlParser from 'react-html-parser';
const ModalCVDocente = ({dataDocente}) => {
    return (
      <div
        className="modal fade bd-example-modal-lg"
        style={{ backgroundColor: "rgba(41,48,59,.6)" }}
        id="modal-cvd"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          style={{ maxWidth: "700px" }}
        >
          <div className="modal-content" style={{ background: "#29303b" }}>
            <div className="modal-header" style={{ borderBottom: "none" }}>
              <h5 className="modal-title text-white" id="exampleModalLabel">
                Docente: {dataDocente.nombre_usuario} {dataDocente.apellido_usuario}
              </h5>
              <button
                type="button"
                className="close text-white"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-content" style={{ background: "#29303b", color:'#fff' }}>
              <div>
              <div className='p-5' dangerouslySetInnerHTML={{__html:dataDocente.descripcion}}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}
 
export default ModalCVDocente;